var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6288 15.9989C20.551 15.9052 20.4745 15.8114 20.3995 15.7209C19.3683 14.4736 18.7444 13.7208 18.7444 10.1897C18.7444 8.36156 18.307 6.86156 17.445 5.73656C16.8094 4.90547 15.9502 4.275 14.8177 3.80906C14.8031 3.80096 14.7901 3.79032 14.7792 3.77766C14.3719 2.41359 13.2572 1.5 12 1.5C10.7428 1.5 9.62861 2.41359 9.22127 3.77625C9.21041 3.78847 9.19758 3.79877 9.1833 3.80672C6.54049 4.89469 5.25611 6.98203 5.25611 10.1883C5.25611 13.7208 4.63314 14.4736 3.60095 15.7195C3.52595 15.81 3.44955 15.9019 3.37174 15.9975C3.17074 16.2399 3.04339 16.5348 3.00476 16.8473C2.96613 17.1598 3.01784 17.4769 3.15377 17.7609C3.44299 18.3703 4.05939 18.7486 4.76299 18.7486H19.2422C19.9425 18.7486 20.5547 18.3708 20.8449 17.7642C20.9814 17.4801 21.0336 17.1628 20.9953 16.8499C20.957 16.537 20.8298 16.2417 20.6288 15.9989ZM12 22.5C12.6774 22.4995 13.342 22.3156 13.9233 21.9679C14.5046 21.6202 14.981 21.1217 15.3019 20.5252C15.317 20.4966 15.3245 20.4646 15.3236 20.4322C15.3227 20.3999 15.3134 20.3684 15.2967 20.3407C15.28 20.313 15.2564 20.2901 15.2283 20.2742C15.2001 20.2583 15.1683 20.25 15.136 20.25H8.86502C8.83264 20.2499 8.80078 20.2582 8.77255 20.274C8.74432 20.2899 8.72067 20.3128 8.70392 20.3405C8.68716 20.3682 8.67787 20.3997 8.67694 20.4321C8.67601 20.4645 8.68347 20.4965 8.69861 20.5252C9.01949 21.1216 9.49579 21.6201 10.077 21.9678C10.6582 22.3155 11.3227 22.4994 12 22.5Z",
    fill: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 5.5,
    r: 2.5,
    fill: "#FF2B2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.a585fee2928ca7360abd7251230190fb.svg";
export { ForwardRef as ReactComponent };